import _isEmpty from 'lodash/isEmpty'

import loSto from '../config/loSto'
import pubSub from '../lib/util/pubSub'
import { logger } from '../lib/logging'
import { EMR_INTEGRATION_STATUS, LO_STO, SECONDARY_EMR_TYPE } from '../lib'
import emrIntegrationService from '../services/emrIntegration'
import { EMR_INTEGRATION_DETAILS_UPDATE } from '../constants/pubSub.events'
import { updateEmrFhirTokens } from '../rest'

// EPIC token expiry time is 3600(1 hour) hence taking the buffer time as 5 minutes(300)
const EPIC_TOKEN_REFRESH_TIME_BUFFER = 300 // This is in seconds

// CERNER token expiry time is 600(10 minutes) hence taking the buffer time as 1 minutes(60)
const CERNER_TOKEN_REFRESH_TIME_BUFFER = 60 // This is in seconds

const isEpicOrCernerIntegration = (emr) =>
  emr === SECONDARY_EMR_TYPE.EPIC_EMR || emr === SECONDARY_EMR_TYPE.CERNER_EMR

const isEmrIntegrationToolBarVisible = () => {
  const emrIntegrationDetails = loSto.get(LO_STO.EMR_INTEGRATION_DETAILS) || {}
  const { emrIntegrated, status, emr } = emrIntegrationDetails
  if (
    emrIntegrated &&
    isEpicOrCernerIntegration(emr) &&
    !_isEmpty(status) &&
    status === EMR_INTEGRATION_STATUS.FAILED
  ) {
    return true
  }
  return false
}

const getEpicTokenRefreshHandler = (epicRefreshToken, expiryTime) => {
  let timeToRefreshToken = expiryTime - EPIC_TOKEN_REFRESH_TIME_BUFFER

  const handleEpicTokenRefresh = () => {
    const { config, emr } = loSto.get(LO_STO.EMR_INTEGRATION_DETAILS) || {}
    if (_isEmpty(config)) {
      logger.info('[EMR Token Refresh]: No configuration found')
      return
    }

    if (emr !== SECONDARY_EMR_TYPE.EPIC_EMR) {
      logger.info('[EMR Token Refresh]: Not EPIC emr')
      return
    }

    const emrAccessToken = loSto.get(LO_STO.FHIR_ACCESS_TOKEN)
    if (_isEmpty(emrAccessToken)) {
      logger.info('[EMR Token Refresh]: Access token is Empty or Invalid')
      return
    }

    setTimeout(() => {
      emrIntegrationService
        .refreshEpicToken(config, epicRefreshToken)
        .then((response) => {
          const { access_token, expires_in } = response
          loSto.set(LO_STO.FHIR_ACCESS_TOKEN, access_token)
          updateEmrFhirTokens(emr, access_token)
          timeToRefreshToken = expires_in - EPIC_TOKEN_REFRESH_TIME_BUFFER
          handleEpicTokenRefresh()
        })
        .catch((error) => {
          logger.error('[EMR Token Refresh]:', error)
          const emrIntegrationDetails = loSto.get(
            LO_STO.EMR_INTEGRATION_DETAILS
          )
          loSto.set(LO_STO.EMR_INTEGRATION_DETAILS, {
            ...emrIntegrationDetails,
            status: EMR_INTEGRATION_STATUS.FAILED
          })
          pubSub.publish(EMR_INTEGRATION_DETAILS_UPDATE)
        })
    }, timeToRefreshToken * 1000)
  }
  return handleEpicTokenRefresh
}

const getCernerTokenRefreshHandler = (cernerRefreshToken, expiryTime) => {
  let timeToRefreshToken = expiryTime - CERNER_TOKEN_REFRESH_TIME_BUFFER
  const handleCernerTokenRefresh = () => {
    const { config, emr } = loSto.get(LO_STO.EMR_INTEGRATION_DETAILS) || {}
    if (_isEmpty(config)) {
      logger.info('[EMR Token Refresh]: No configuration found')
      return
    }

    if (emr !== SECONDARY_EMR_TYPE.CERNER_EMR) {
      logger.info('[EMR Token Refresh]: Not CERNER emr')
      return
    }

    const emrAccessToken = loSto.get(LO_STO.FHIR_ACCESS_TOKEN)
    if (_isEmpty(emrAccessToken)) {
      logger.info('[EMR Token Refresh]: Access token is Empty or Invalid')
      return
    }

    setTimeout(() => {
      emrIntegrationService
        .refreshCernerToken(config, cernerRefreshToken)
        .then((response) => {
          const { access_token, expires_in } = response
          loSto.set(LO_STO.FHIR_ACCESS_TOKEN, access_token)
          updateEmrFhirTokens(emr, access_token)
          timeToRefreshToken = expires_in - CERNER_TOKEN_REFRESH_TIME_BUFFER
          handleCernerTokenRefresh()
        })
        .catch((error) => {
          logger.error('[EMR Token Refresh]:', error)
          const emrIntegrationDetails = loSto.get(
            LO_STO.EMR_INTEGRATION_DETAILS
          )
          loSto.set(LO_STO.EMR_INTEGRATION_DETAILS, {
            ...emrIntegrationDetails,
            status: EMR_INTEGRATION_STATUS.FAILED
          })
          pubSub.publish(EMR_INTEGRATION_DETAILS_UPDATE)
        })
    }, timeToRefreshToken * 1000)
  }

  return handleCernerTokenRefresh
}

export {
  isEmrIntegrationToolBarVisible,
  getEpicTokenRefreshHandler,
  getCernerTokenRefreshHandler
}
